import type { Role } from "../const/roles"
import { useSsoService } from "./useSso"

export function useRoleCheck(role: Role): boolean
export function useRoleCheck(): { checkRole: (role: Role) => boolean }
export function useRoleCheck(role?: Role) {
  const sso = useSsoService()
  const roles = sso.getRoles() || []
  const checkRole = (roleToCheck: Role) => roles.includes(roleToCheck)

  return role ? checkRole(role) : { checkRole }
}
